<template>
    <div class="main">
        <my_menu></my_menu>

        <div class="content">
            <div class="tabs_box">
                <Tabs size="small" v-model="tabs_index" type="card">
                    <TabPane name="0" label="项目列表">
                    </TabPane>
                    <TabPane name="1" label="每日排班" disabled>
                    </TabPane>
                    <TabPane name="2" label="打卡设置" disabled>
                    </TabPane>
                </Tabs>
            </div>
            <div class="table_box" v-if="(tabs_index == 0)">
                <Spin fix size="large" v-if="table_loading"></Spin>
                <Table size="small" :height="windowHeight - 100" :columns="columns" :data="table_data">
                    <template #action="{ row }">
                        <Button style="font-size:10px" @click="paipan(row)">每日排班</Button>
                        <Button style="font-size:10px;margin-left:10px;" @click="click_daka(row)">打卡设置</Button>
                    </template>
                </Table>
                <div class="content_page">
                    <Page :total="total_count" :page-size="limit" v-model="page" @on-change="page_change" />
                </div>
            </div>
            <div v-if="(tabs_index == 1)">
                <daily_shift :current_project="current_project" ref="daily_shift"></daily_shift>
            </div>
            <div v-if="tabs_index == 2">
                <daka_setting :current_project="current_project" ref="daka_setting"></daka_setting>
            </div>

        </div>

    </div>


</template>

<script>
import my_menu from '@/component/menu/menu.vue'
import { http, open_new_page } from "@/utils/http.js";
import daily_shift from '../daily_settlement/component/shift.vue'
import daka_setting from '../daily_settlement/component/daka_setting.vue'


export default {
    components: {
        my_menu,
        daily_shift,
        daka_setting
    },

    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

            //系统列表
            table_data: [],
            columns: [],
            table_loading: false,
            page: 1,

            tabs_index: 0,
            tabs_item_list: [{ name: '项目列表' }],



            current_project: '',
            tabs_append: '',
            page: 1,
            total_count: 0,
            limit: 20,

        }
    },


    mounted() {

        var that = this
        window.onresize = () => {

            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                window.fullWidth = document.documentElement.clientWidth;
                that.windowHeight = window.fullHeight;  // 高
                that.windowWidth = window.fullWidth; // 宽
            })()
        };

        this.get_my_project_list()
    },

    methods: {

        click_daka(item) {
            this.tabs_index = '2'
            this.current_project = item
        },

        paipan(item) {
            console.log(item)
            this.tabs_index = '1'
            this.current_project = item
            console.log(this.tabs_index)
        },


        page_change(e) {
            this.page = e
            this.get_my_project_list()

        },



        //获取项目列表
        get_my_project_list() {
            var that = this
            var obj = {
                page: this.page
            }
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/daily/project_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.table_data = res.data.project_list
                        that.columns = res.data.columns
                        that.limit = res.data.limit
                        that.total_count = res.data.total_count

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.tabs_box {
    padding: 5px 10px 0 10px;
}

.tabs_div {
    background-color: #fff;
}

.table_num_title {
    width: 50px;
    flex-shrink: 0;
}

.table_num_div {
    width: 30px;
    flex-shrink: 0;
}

.table_click {
    cursor: pointer;
    color: #515a6e;
    width: 120px;
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.table_click:hover {

    color: #0c6ce2;
}

.table_a {
    cursor: pointer;
    color: #515a6e;
    margin-right: 10px;
}

.table_a:hover {
    color: #0c6ce2;

}

.table_a_box {
    display: flex;

}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
    background-color: #fff;
    padding: 0px 10px 0 10px;
    border-radius: 5px;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    width: calc(100% - 180px);
    background-color: rgb(255, 255, 255);
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;

}

.main {
    background: #f5f7f9;
    min-height: 100vh;
    min-width: 1200px
}
</style>